import { cn } from '@/trailmix/lib/cn';

type ContainerProps = {
    children: React.ReactNode;
    className?: string;
};

export function Container({ children, className }: ContainerProps) {
    return (
        <main className={cn('mx-auto w-full max-w-3xl flex-1 px-4 pb-16 pt-8 desktop:px-8', className)}>
            {children}
        </main>
    );
}
